import GeneralModal from '../../../components/GeneralModal/GeneralModal'
import { usePlayerQuery } from '../../../api/api'
import LoadingBlocker from '../../../components/LoadingSpinner/LoadingBlocker'
import { LocalToastTarget, useLocalToast } from 'react-local-toast'
import { ReactComponent as CopyIcon } from 'assets/icons/copy-link.svg'

const PlayerLinkModal = ({ id, onRequestClose }) => {
  const { showToast } = useLocalToast()
  const { data: playerData, isFetching } = usePlayerQuery(id)
  const link = `<div id="${playerData?.id}"><script src="https://sharefol.io/api/player/${playerData?.id}" async type="text/javascript"></script></div>`
  const toastName = `copy-${id}`

  async function handleCopyClick(evt) {
    evt.stopPropagation()
    showToast(toastName, 'Copied!', { duration: 1250 })

    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(link)
    } else {
      document.execCommand('copy', true, link)
    }
  }

  return (
    <GeneralModal
      isOpen={id}
      onRequestClose={onRequestClose}
      title="Embedded Player Code"
    >
      {isFetching ? (
        <LoadingBlocker />
      ) : (
        <div className="flex items-center">
          <div className="flex-1">
            <input type="text" readOnly value={link} />
          </div>
          <div className="pl-2">
            <LocalToastTarget name={toastName}>
              <button
                className="flex justify-center items-center  button icon "
                onClick={handleCopyClick}
                data-tooltip="Copy Link"
              >
                <CopyIcon fill="#eee" height="18" />
              </button>
            </LocalToastTarget>
          </div>
        </div>
      )}
    </GeneralModal>
  )
}

export default PlayerLinkModal
